import { createFileRoute } from '@tanstack/react-router';
import { loginRouteGuards } from '~/lib/session/session.singleton';
import { LoginPage } from '~/modules/users/users.components/login-page';

export const Route = createFileRoute('/auth/login')({ ...loginRouteGuards, component: LoginPage });
